import Stripe from 'stripe'
import { FeaturePackage } from './FeaturePackage'

export interface Subscription {
    packages: FeaturePackage[]
    name: string
    renewal_date: Date
    auto_renew: boolean
}

export type UnresolvedSubscriptionParams = {
    seats?: number
}

export enum SubscriptionStatus {
    ACTIVE = 'active',
    PENDING_CANCELLATION = 'pending_cancellation',
    CANCELLED = 'cancelled',
}

export interface GetSubscriptionsDTO {
    subscriptions: Stripe.Subscription[]
    customer: Stripe.Customer
    payment_methods: Stripe.PaymentMethod[]
}
